import axios from "axios";

const baseURL = 'https://maps.googleapis.com/maps/api/geocode/json';
let apiKey=process.env.REACT_APP_GOOGLE_MAP_API_KEY;

const api = axios.create({
    baseURL,
  });
export const getGeocode = (address) =>
  api.get('', {
    params: {
      address,
      key: apiKey,
    },
  });